<template>
  <div class="cf-card cf-flex cf-flex--column cf-flex--gap-12 cf-cursor-pointer">
    <div class="cf-flex cf-flex--row cf-flex--justify-space-between">
      <h4 class="cf-title cf-title--4">
        Order items
      </h4>

      <p class="cf-subtitle cf-subtitle--2">
        {{ orderSubtotal }}
      </p>
    </div>

    <p class="cf-subtitle cf-subtitle--3 cf-no-wrap-ellipsis-multi-line">
      {{ orderItems }}
    </p>

    <button
      type="button"
      class="cf-button cf-button--primary cf-button--lg cf-button--fill"
      @click="selectOrder"
    >
      Select Order
    </button>
  </div>
</template>


<script>
  import dollars from '@/filters/dollars';

  export default {
    name: 'OpenOrder',

    props: {
      order: {
        type: Object,
        required: true
      }
    },

    computed: {
      orderSubtotal() {
        return dollars(this.order.subtotal);
      },

      orderItems() {
        const orderItemsArray = [];

        this.order.orderItems.forEach((orderItem) => {
          orderItemsArray.push(orderItem.itemDescription);
        });

        return orderItemsArray.join(', ');
      }
    },

    methods: {
      async selectOrder() {
        await this.$store.dispatch('orderAtTable/setTableOrder', this.order);

        this.$emit('callback-handler');

        this.$closeModal('select-table-top-device-order-modal');
      }
    }
  };
</script>
